import FamilyDetailsActions from "@frameworks/web/redux/actions/Reports/FamilyTagging/FamilyDetails";
import ConsolidatedDetailsActions from "@frameworks/web/redux/actions/Reports/FamilyTagging/ConsolidatedDetails";
export default () => {
    return {
        familyDetails: new FamilyDetailsActions(),
        consolidatedDetails: new ConsolidatedDetailsActions(),
    };
};
